import React from 'react';
import { App } from './components/App';
import { createRoot } from 'react-dom/client';
import {
  jiraExpressionLanguageConfiguration,
  jiraExpressionMonarchLanguage,
} from './components/languages/JiraExpressionLanguage';
import { monaco } from 'react-monaco-editor';
import '@atlaskit/css-reset/dist/bundle.css';

self.MonacoEnvironment = {
  getWorkerUrl: function (_moduleId, label) {
    if (label === 'json') {
      return '/assets/language/json/json.worker.js';
    }
    return '/assets/editor/editor.worker.js';
  },
};

const jiraExpressionLanguageId = 'jira-expressions-language';
monaco.languages.register({
  id: jiraExpressionLanguageId,
});
monaco.languages.setMonarchTokensProvider(
  jiraExpressionLanguageId,
  jiraExpressionMonarchLanguage,
);
monaco.languages.setLanguageConfiguration(
  jiraExpressionLanguageId,
  jiraExpressionLanguageConfiguration,
);

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(<App />);
